module.exports = __webpack_public_path__ + "img/code.988bacf3.png";